import type { Content } from './Content'

export const getQuestionNameByIndex = (currentIndex: number, content: Content) => {
  if (currentIndex === 1) {
    return content.name.questionKey
  }
  if (currentIndex === 2) {
    return content.members.questionKey
  }
  if (currentIndex === 3) {
    return content.role.questionKey
  }
  return undefined
}
